<template>
  <div class="user-dash-support-container">
      <div class="user-dash-support-row">
          <ActiveTickets></ActiveTickets>
          <TicketNotifications></TicketNotifications>
          <LiveChat></LiveChat>
      </div>
      <TicketActivityTable></TicketActivityTable>
  </div>
</template>

<script>
import ActiveTickets from "../../../components/user/support/ActiveTickets"
import TicketNotifications from "../../../components/user/support/TicketNotifications"
import LiveChat from "../../../components/user/support/LiveChat"

import TicketActivityTable from "../../../components/user/support/TicketActivityTable"
export default {
    components: {
        ActiveTickets,
        TicketNotifications,
        LiveChat,
        TicketActivityTable
    }
}
</script>

<style scoped>
.user-dash-support-row{
    display: flex;
    width: 100%;
    justify-content: space-between;
}

@media (max-width: 1110px){
    .user-dash-support-row {
        flex-wrap: wrap !important;
    }
    .support-active-tickets-container{
        width: 100% !important;
        max-width: 100% !important;
        flex: 100% !important;
        margin-bottom: 20px;
    }
}
</style>